import { createContext, useContext } from 'react'

interface TimelineConfigContextValue {
  isReadonly: boolean
  editingTaskId: number | undefined
  onTaskClick: (taskId: number) => void
  onAppointmentClick: ((appointmentId: string) => void) | undefined
  canRescheduleCompleted: boolean
}

const TimelineConfigContext = createContext<TimelineConfigContextValue>({
  isReadonly: false,
  editingTaskId: undefined,
  onTaskClick: () => {},
  onAppointmentClick: undefined,
  canRescheduleCompleted: false,
})

export const TimelineConfigProvider = TimelineConfigContext.Provider

export function useTimelineConfig(): TimelineConfigContextValue {
  return useContext(TimelineConfigContext)
}
